var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGames(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 5.16123e-06C11.4822 -0.00150219 12.9462 0.327177 14.2856 0.962167C15.6249 1.59716 16.806 2.52251 17.743 3.67101L11.414 10L17.743 16.329C16.806 17.4775 15.6249 18.4029 14.2856 19.0378C12.9462 19.6728 11.4822 20.0015 10 20C4.477 20 0 15.523 0 10C0 4.47701 4.477 5.16123e-06 10 5.16123e-06ZM10 3.00001C9.60218 3.00001 9.22064 3.15804 8.93934 3.43934C8.65804 3.72065 8.5 4.10218 8.5 4.50001C8.5 4.89783 8.65804 5.27936 8.93934 5.56067C9.22064 5.84197 9.60218 6.00001 10 6.00001C10.3978 6.00001 10.7794 5.84197 11.0607 5.56067C11.342 5.27936 11.5 4.89783 11.5 4.50001C11.5 4.10218 11.342 3.72065 11.0607 3.43934C10.7794 3.15804 10.3978 3.00001 10 3.00001Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGames);
export default __webpack_public_path__ + "static/media/games.640971fba800b4aaa91fc0b322c05f8d.svg";
export { ForwardRef as ReactComponent };